module.exports = __webpack_public_path__ + "static/media/MJ.5a6980d4.png";